export default "__VITE_ASSET__8021539b__"